/*
 * @Description: 配置
 * @Author: 琢磨先生
 * @Date: 2024-07-11 17:45:49
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2024-08-14 11:06:42
 */
export default {
	// oss处理
	OSSSETTING: {
		aliyun_oss_access_id: 'LTAI5t5yQ8mZMddu6hnG5avo',
		aliyun_oss_access_secret: '0zzextXGDNkNrIZlkcjhqGr5f4Du1T',
		aliyun_oss_bucket: 'dingchengoa',
		aliyun_oss_endpoint: 'oss-cn-beijing.aliyuncs.com',
		aliyun_oss_region: 'oss-cn-beijing',
		aliyun_oss_domain: 'https://dingchengoa.oss-cn-beijing.aliyuncs.com'
	},
	/**
	 * api请求host地址
	 */
	HOST:
		// process.env.NODE_ENV === 'development'
		// 	? 'http://127.0.0.1:8001/api'
		// 	: 'http://dc-api.dcjy.top/api',

		process.env.NODE_ENV === 'development'
			? 'https://erp-api.dcjy.top/api'
			: 'https://erp-api.dcjy.top/api',

	HOST2: process.env.NODE_ENV === 'development' ? '/api' : 'https://erp-api.dcjy.top/api',

	HOST3:
		process.env.NODE_ENV === 'development'
			? 'http://222.174.167.26:3397'
			: 'http://222.174.167.26:3397',

	HOST4: process.env.NODE_ENV === 'development' ? '/prod-api' : '/prod-api',

	/**
	 * 数据中台子应用（乾坤微前端）地址
	 */
	DATA_CENTER_SUB_APP_URL: '/micro-data-middle/',

	/**
	 * 数据中台子应用内部路由（加载后跳转到 erpHome）
	 */
	DATA_CENTER_SUB_APP_ROUTE: '/erpHome',

	// process.env.NODE_ENV === 'development'
	// 	? 'http://222.174.167.26:3999/api'
	// 	: 'http://222.174.167.26:3999/api',

	/**
	 * 登录账号本次存储
	 */
	ACCOUNT_STORE_KEY: 'login_account',

	/**
	 * 本地缓存token名称
	 */
	TOKEN: 'emp.token',

	/**
	 * 本地缓存用户信息
	 */
	USERINFO: 'DC-info',

	/**
	 * 本地缓存 部门
	 */
	DEPT: 'DC-dept',

	/**
	 * 本地缓存 部门 -- 学习中心
	 */
	STUDY: 'DC-study',

	/**
	 * 本地缓存 员工
	 */
	EMP: 'DC-emp',

	/**
	 * 项目app key
	 */
	APP_KEY: 'dc_admin',

	/**
	 * 平台 web pc
	 */
	APP_PLATFORM: 0,

	/**
	 * 本地缓存api key
	 */
	API_STORE_KEY: 'api_store',
	/**
	 * 文件下载的时候的域名替换直接访问域名 http://dcoaoss.yuandingcheng.com
	 */
	OSS_DOWNLOAD: 'https://dingchengoa.oss-cn-beijing.aliyuncs.com'
}
